// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5b14af6","893":"379f2fc5","976":"962cf2c8"}[chunkId] + ".chunk.js";
};